// src/config.ts

// API base URL - defaults to same host in development
//export const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || '';

// API base URL, defaults to same host in production
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

console.log('API_BASE_URLCONFIG TS  ---- ', API_BASE_URL);

// Application settings
export const APP_NAME = 'Tripper';
export const APP_DESCRIPTION = 'Your next adventure companion';

// Authentication settings
export const AUTH_COOKIE_NAME = 'tripper_session';
export const SESSION_DURATION = 60 * 60 * 24 * 7; // 7 days in seconds

// Feature flags
export const FEATURES = {
  SOCIAL_LOGIN: import.meta.env.VITE_FEATURE_SOCIAL_LOGIN === 'true',
  WAITLIST: import.meta.env.VITE_FEATURE_WAITLIST === 'true',
  ADMIN_PANEL: import.meta.env.VITE_FEATURE_ADMIN_PANEL === 'true',
};

// Social login provider IDs
export const PROVIDERS = {
  GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID,
  MICROSOFT_CLIENT_ID: import.meta.env.VITE_MICROSOFT_CLIENT_ID,
  APPLE_CLIENT_ID: import.meta.env.VITE_APPLE_CLIENT_ID,
};

// Email configuration
export const EMAIL_CONFIG = {
  FROM_ADDRESS: import.meta.env.EMAIL_FROM || 'noreply@trippymate.ai',
  SUPPORT_EMAIL: 'support@trippymate.ai',
};

// Invite system configuration
export const INVITE_CONFIG = {
  INVITE_QUOTA: parseInt(import.meta.env.INVITE_QUOTA || '100'),
  CODE_EXPIRY_HOURS: parseInt(import.meta.env.INVITE_CODE_EXPIRY_HOURS || '48'),
};

// Security settings
export const SECURITY_CONFIG = {
  PASSWORD_MIN_LENGTH: 8,
  PASSWORD_REQUIRES_SPECIAL_CHAR: true,
  PASSWORD_REQUIRES_NUMBER: true,
  MAX_LOGIN_ATTEMPTS: 5,
  LOCKOUT_DURATION_MINUTES: 30,
};


// Authentication settings
export const AUTH_SETTINGS = {
  TOKEN_STORAGE_KEY: 'authToken',
  USER_STORAGE_KEY: 'userData',
  SESSION_TOKEN_KEY: 'sessionToken',
  REMEMBER_EMAIL_KEY: 'rememberedEmail',
  SESSION_DURATION_DAYS: 7,
};

/* // Feature flags
export const FEATURES = {
  SOCIAL_LOGIN: true,
  WAITLIST: true,
  ADMIN_PANEL: true,
  PASSWORD_RESET: false, // Not implemented yet
}; */

/* // Email service configuration
export const EMAIL_CONFIG = {
  FROM_ADDRESS: 'noreply@trippymate.ai',
  SUPPORT_EMAIL: 'support@trippymate.ai',
}; */

/* // Invite system configuration
export const INVITE_CONFIG = {
  INVITE_QUOTA: 100,
  CODE_EXPIRY_HOURS: 48,
}; */

/* // Security settings
export const SECURITY_CONFIG = {
  PASSWORD_MIN_LENGTH: 8,
  PASSWORD_REQUIRES_SPECIAL_CHAR: true,
  PASSWORD_REQUIRES_NUMBER: true,
  MAX_LOGIN_ATTEMPTS: 5,
  LOCKOUT_DURATION_MINUTES: 30,
}; */

// Social login providers
export const SOCIAL_PROVIDERS = {
  GOOGLE: {
    ENABLED: true,
    NAME: 'Google',
  },
  MICROSOFT: {
    ENABLED: true,
    NAME: 'Microsoft',
  },
  APPLE: {
    ENABLED: true,
    NAME: 'Apple',
  },
};